import { PropTypes } from "prop-types";

import TabButton from "../formInputs/buttons/TabButton";

const TabGroup = ({ activeTab, handleClick, tabs }) => {
    if (!tabs) {
        return null;
    }

    return (
        <div className="guardian-content-area">
            {tabs.map((tab, index) => {
                return (
                    <TabButton
                        className={activeTab === index ? "guardian-tab tab-button-selected" : "guardian-tab tab-button"}
                        key={`${tab}-${index}`}
                        id={`sub-${index}`}
                        onClick={handleClick}
                        onKeyDown={handleClick}
                        role="button"
                        size="large"
                        tabIndex={0}
                    >
                        {tab}
                    </TabButton>
                );
            })}
        </div>
    );
};

TabGroup.propTypes = {
    activeTab: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    handleClick: PropTypes.func.isRequired,
    tabs: PropTypes.instanceOf(Array)
};

TabGroup.defaultProps = {
    activeTab: 0,
    tabs: null
};

export default TabGroup;
